import { styled } from "@mui/material";

export const HorizontalList = styled("div")({
  overflowX: "auto",
  whiteSpace: "nowrap",
  WebkitOverflowScrolling: "touch",
});
